import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ImageComponent } from '../image/image.component';
import { SettingsService } from '@app/_services/settings.service';

@Component({
    selector: 'app-all-features-disabled-block',
    imports: [
        CommonModule,
        ImageComponent
    ],
    templateUrl: './all-features-disabled-block.component.html',
    styleUrl: './all-features-disabled-block.component.scss'
})

export class AllFeaturesDisabledBlockComponent {

  private router = inject(Router);

  constructor(
    public ss: SettingsService,
  ) {
  }

  navigateToFeatures() {
    this.router.navigate(['/features']);
  }
}
